import { render, staticRenderFns } from "./BtCheckbox.vue?vue&type=template&id=05b033b9&scoped=true&lang=pug&"
import script from "./BtCheckbox.vue?vue&type=script&lang=js&"
export * from "./BtCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BtCheckbox.vue?vue&type=style&index=0&id=05b033b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b033b9",
  null
  
)

export default component.exports